module.exports = __webpack_public_path__ + "static/media/Vision_mission.2d3a230e.jpg";